import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { JitsiMeeting } from "@jitsi/react-sdk";

type PatientJitsiDialogProps = {
  open: boolean;
  onClose: () => void;
  roomName: string;
  token?: string;
  displayName?: string;
  email?: string;
  closeLabel?: string;
};

export const PatientJitsiDialog: React.FC<PatientJitsiDialogProps> = ({
  open,
  onClose,
  roomName,
  token,
  displayName,
  email,
  closeLabel = "Close",
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Jitsi Video Call</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1, height: { xs: 420, md: 620 } }}>
          {open && roomName && token ? (
            <JitsiMeeting
              domain="videocall.sentioweb.com"
              roomName={roomName}
              userInfo={{
                displayName: displayName || "User",
                email: email || "user@example.com",
              }}
              getIFrameRef={(iframeRef) => {
                iframeRef.style.height = "100%";
                iframeRef.style.width = "100%";
                iframeRef.setAttribute(
                  "allow",
                  "camera *; microphone *; fullscreen; display-capture; autoplay",
                );
              }}
              onReadyToClose={onClose}
              jwt={token}
            />
          ) : (
            <Typography color="textSecondary">
              Unable to start call. Missing patient room or auth token.
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{closeLabel}</Button>
      </DialogActions>
    </Dialog>
  );
};
